// hooks
import { useState, useEffect } from 'react'
import { useMetamask } from 'contexts/Metamask'
import useSwitch from 'hooks/useSwitch'

// libraries
import { toast } from 'react-toastify'

// components
import ProgressBar from 'components/ProgressBar'
import Button from 'components/Button'
import Navbar from 'components/Navbar'

// helpers
import Contracts from 'helpers/contracts'
import { fromNow } from 'utilities/utils'

// styles
import classes from './ClaimTokens.module.scss'
import variables from 'variables.module.scss'
import { APP_CONFIG } from 'config'

export default function ClaimTokens() {
  const { account, isConnectedToAllowedNetwork, handleTransactionError } = useMetamask()
  const isTransactionInProgress = useSwitch()
  const [claim, setClaim] = useState<any>({
    totalAmount: 0,
    amountClaimed: 0,
    claimableAmount: 0,
    endTime: null,
    status: '',
    // paused: false,
  })

  const fetchClaimDetails = async () => {
    if (!(await isConnectedToAllowedNetwork())) return

    try {
      const { Vesting } = Contracts.instances
      const claim = await Vesting?.methods.getClaim(account).call({ from: account })
      const claimableAmount = await Vesting?.methods.claimableAmount(account).call({ from: account })
      let status = ``
      console.log(claim)
      if(!claim[0] || claim[5] === '0'){
        status = "NA"
      }
      else if (Math.round(Date.now() / 1000) > parseInt(claim[5])) {
        status =  'Complete'
      } else {
        status = `${fromNow(parseInt(claim[5]))} Till Maturity`
      }
      if (claim[0]) {
        setClaim({
          totalAmount: parseInt(claim[1]) + parseInt(claim[7]),
          amountClaimed: claim[6],
          claimableAmount: claimableAmount,
          endTime: claim[5],
          status,
        }) 
      }
      else {
        setClaim({
          totalAmount: 0,
          amountClaimed: 0,
          claimableAmount: 0,
          endTime: claim[5],
          status,
        }) 
      }
    } catch (err) {
      handleTransactionError(err)
    }
  }

  useEffect(() => {
    fetchClaimDetails()
    const claimInterval = setInterval(fetchClaimDetails, 60000)
    return () => clearInterval(claimInterval)
  }, [])

  const claimTokens = async () => {
    if (!(await isConnectedToAllowedNetwork())) return

    try {
      isTransactionInProgress.true()
      const { Vesting } = Contracts.instances
      await Vesting?.methods.claim().send({ from: account })
      await fetchClaimDetails()
      toast.success('Tokens Claimed Successfully')
    } catch (err) {
      handleTransactionError(err)
    }

    isTransactionInProgress.false()
  }

  const totalAmount = claim?.totalAmount / 1e18
  const amountClaimed = claim?.amountClaimed / 1e18
  const userClaimableAmount = claim?.claimableAmount / 1e18

  return (
    <div className={classes.root}>
      <Navbar />
      <main className={classes.content}>
        <div className={classes.card}>
          <p className={classes.title}>Claim Tokens</p>
          <table>
            <tbody>
              <tr className={classes.inputGroup}>
                <td className={classes.label}>Availability</td>
                <td>
                  <ProgressBar
                    progress={(parseFloat(userClaimableAmount.toString()) / (totalAmount-amountClaimed)) * 100}
                    bgColor={variables.progressBarBg}
                    fillColor={variables.primaryColor}
                  />
                </td>
                <td>
                  <p className={classes.desc}>
                    <span>{parseFloat(userClaimableAmount.toString()).toFixed(2)}</span> /{' '}
                    {(totalAmount-amountClaimed).toFixed(2)} Claimable
                  </p>
                </td>
              </tr>
              <tr className={classes.inputGroup}>
                <td className={classes.label}>Claimed</td>
                <td>
                  <ProgressBar
                    progress={(amountClaimed / (userClaimableAmount+amountClaimed)) * 100}
                    bgColor={variables.progressBarBg}
                    fillColor={variables.primaryColor}
                  />
                </td>
                <td>
                  <p className={classes.desc}>
                    <span>{amountClaimed.toFixed(2)}</span> / {(userClaimableAmount+amountClaimed).toFixed(2) || '0.00'} Claimed
                  </p>
                </td>
              </tr>
              <tr className={classes.inputGroup}>
                <td className={classes.label}>Time Left</td>
                <td colSpan={2}>
                  <p className={classes.timeLeft}>{claim.status}</p>
                </td>
              </tr>
            </tbody>
          </table>
          <Button
            text={`Claim ${APP_CONFIG.VESTING_TOKEN}`}
            className={classes.button}
            onClick={claimTokens}
            loading={isTransactionInProgress.value}
          // disabled={(totalAmount !== amountClaimed && !claim?.isActive)}
          />
        </div>
      </main>
    </div>
  )
}
